// Type Imports
import { VZephyrsConfig, Zephyr } from '../interface';

const getUnitTypeCountTxt = (
  unitList: Zephyr[],
  unitType: number,
  vZephyrsConfig: VZephyrsConfig,
) => {
  const { length } = unitList.filter((z: Zephyr) => z.type === unitType);
  return length;
};

export { getUnitTypeCountTxt };
